import {Component, OnInit, ViewChild} from '@angular/core';
import {ConfirmDialogComponent} from "../../../../../../confirm-dialog/confirm-dialog.component";
import {MatTableDataSource} from "@angular/material/table";
import {MatSelectChange} from "@angular/material/select";
import {Router} from "@angular/router";
import {Observable, Subscription} from "rxjs";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {AngularFireDatabase} from "@angular/fire/compat/database";
import {HighlightService} from "../../highlight.service";
import {CentreService} from "../../../../../../services/centre.service";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {Centre} from "../../../../../../interfaces/Centres";
import {FullChild} from "../../../../../../interfaces/FullChild";
import {LogService} from "../../../../../../services/log.service";
import {FinancialYearService} from "../../../../../../services/financial-year.service";

@Component({
  selector: 'app-center-highlight-list',
  templateUrl: './center-highlight-list.component.html',
  styleUrls: ['./center-highlight-list.component.scss']
})
export class CenterHighlightListComponent implements OnInit {
  startDate1: Date | null = null;
  endDate1: Date | null = null;
  displayedColumns: String[] = ['position', 'centreCode', 'highlightType', 'eventDate', 'Action'];
  @ViewChild(MatPaginator) paginator1!: MatPaginator;
  @ViewChild(MatSort) sort1!: MatSort;
  dataSource!: MatTableDataSource<any>;
  centres$!: Observable<Centre[]>;
  children$?: Observable<FullChild[]>
  highlighTypeList$!: Observable<any[]>
  mSelectedCentre: any;
  mChildren!: FullChild[];
  selectedChildData: string = '';
  selectedChild: any;
  userData = JSON.parse(localStorage.getItem('userData')!)

  private subscriptions: Subscription[] = [];  // Track all subscriptions
  constructor(
    private mRouter: Router,
    private firestore: AngularFirestore,
    public dialog: MatDialog,
    private snackBar: MatSnackBar,
    private mDatabase: AngularFireDatabase,
    private highlightService: HighlightService,
    private logService: LogService,
    private readonly mCentreService: CentreService,
    private readonly financialYearService: FinancialYearService) {
    this.centres$ = this.mCentreService.getAllCentres();
    this.highlighTypeList$ = mDatabase.list<any>('types/Highlights Type').valueChanges();
  }

  ngOnInit(): void {
    const fy = this.financialYearService.getCurrentFinancialYear();
    this.startDate1 = fy.startDate;
    this.endDate1 = fy.endDate;
    this.featchHighlightData()
  }

  featchHighlightData() {
    const sub = this.highlightService.getCentreHighlights().subscribe((data: any) => {
      console.log(data)
      this.dataSource = new MatTableDataSource(data);
      this.dataSource.paginator = this.paginator1;
      // alert(JSON.stringify(data, null, 2));
    })
    this.subscriptions.push(sub);
  }


  applyFilter($event: Event) {
    const filterValue = ($event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  clearAll() {
    this.mSelectedCentre = ''
    const fy = this.financialYearService.getCurrentFinancialYear();
    this.startDate1 = fy.startDate;
    this.endDate1 = fy.endDate;
    this.featchHighlightData();
  }

  searchChildByCode() {
    if (!this.mSelectedCentre && !this.startDate1 && !this.endDate1) {
      this.dataSource.filter = '';
      return;
    }
    const sub = this.highlightService.getCentreHighlights().subscribe((data: any[]) => {
      let filteredData = data;
      if (this.mSelectedCentre) {
        filteredData = filteredData.filter(item => item.centreCode === this.mSelectedCentre);
      }
      if (this.startDate1 && this.endDate1) {
        const start = new Date(this.startDate1);
        start.setHours(0, 0, 0, 0);
        const end = new Date(this.endDate1);
        end.setHours(23, 59, 59, 999);
        filteredData = filteredData.filter(item => {
          const rawTimestamp = item.eventDate;
          if (!rawTimestamp || !rawTimestamp.seconds) return false;
          const itemDate = new Date(rawTimestamp.seconds * 1000);
          return itemDate >= start && itemDate <= end;
        });
      }
      this.dataSource = new MatTableDataSource(filteredData);
      console.log('Filtered data:', filteredData);
    });
    this.subscriptions.push(sub);
  }


  ViewReportChildCaseStudy(id: any) {
    this.mRouter.navigateByUrl(`home/reports/center-highlight-view/${id}`);
  }

  editReport(id: any) {
    this.mRouter.navigateByUrl(`home/reports/add-center-highlight/${id}`)

  }

  deleteReport(id: any, centreCode: string) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
      height: '200px',
      data: {
        title: 'Confirmation',
        message: 'Are you sure you want to delete this highlight?',
      }
    });
    const sub = dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.highlightService.deleteCentreHighlight(id).then(() => {

          let activity = {
            date: new Date().getTime(),
            section: 'Centre Highlights',
            action: 'Delete',
            description: `Centre Hightlight deleted for ${centreCode}  registered  by ${this.userData.userName}  `,
            currentIp: localStorage.getItem('currentip')!
          }
          this.logService.addLog(activity)


          this.snackBar.open('Deleted successfully!', 'Close', {duration: 3000});

        }).catch((error: any) => {
          this.snackBar.open('Error deleting record.', 'Close', {duration: 3000});
          console.error(error);
        });
      }
    });
    this.subscriptions.push(sub);
  }

  addHighlightReport() {
    this.mRouter.navigateByUrl('home/reports/add-center-highlight');

  }

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions to prevent memory leaks
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

}
